import {
  Autocomplete,
  Box,
  Button,
  IconButton,
  TextField,
  useTheme,
} from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../components/Header";
import { useEffect, useState } from "react";
import axios from "axios";
import { tokens } from "../../theme";
import { Delete, Edit, Visibility } from "@mui/icons-material";
import { DataGrid } from "@mui/x-data-grid";
const top100Films = [
  { label: "Admin", year: 1994 },
  { label: "User", year: 1972 },
];

const Form = () => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [mockDataRequests, setMockDataRequests] = useState([]);
  const handleFormSubmit = (values) => {
    console.log(values);
    postData(values);
  };

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const columns = [
    { field: "id", headerName: "ID" },
    {
      field: "fName",
      headerName: "First Name",
      cellClassName: "name-column--cell",
    },
    {
      field: "lName",
      headerName: "Last Name",
      headerAlign: "center",
      align: "left",
      flex: 1,
    },
    {
      field: "email",
      headerName: "Email",
      headerAlign: "center",
      align: "left",
      flex: 0.5,
    },
    {
      field: "contact",
      headerName: "Contact",
      headerAlign: "center",
      align: "left",
      flex: 1,
    },
    {
      field: "address1",
      headerName: "Address 1",
    },
    {
      field: "address2",
      headerName: "Address 2",
    },
    {
      field: "userType",
      headerName: "User Type",
    },
    {
      field: "accessLevel",
      headerName: "Access Level",
      headerAlign: "center",
      align: "center",
      flex: 1,
      renderCell: ({ row: { access } }) => {
        return (
          <Box
            m="0 auto"
            p="5px"
            display="flex"
            justifyContent="center"
            backgroundColor={colors.greenAccent[600]}
            borderRadius="4px"
          >
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                justifyItems: "center",
                padding: "0 10px 0 10px",
              }}
            >
              <IconButton>
                <Edit />
              </IconButton>
              <IconButton>
                <Visibility />
              </IconButton>
              <IconButton>
                <Delete />
              </IconButton>
            </Box>
          </Box>
        );
      },
    },
  ];
  useEffect(() => {
    loadData();
  }, []);

  const loadData = () =>
    axios
      .get("https://matlabspring.df.r.appspot.com/api/v1/student")
      .then((res) => setMockDataRequests(res.data))
      .catch((err) => console.log(err));

  const postData = (values) =>
    axios
      .post("https://matlabspring.df.r.appspot.com/api/v1/student", values)
      .then((res) => loadData())
      .catch((err) => console.log(err));

  return (
    <Box m="20px">
      <Header title="New User" subtitle="Create / Update / Delete Users" />

      <Formik
        onSubmit={handleFormSubmit}
        initialValues={initialValues}
        validationSchema={checkoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box
              display="grid"
              gap="30px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
              sx={{
                "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
              }}
            >
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="First Name"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.fName}
                name="fName"
                error={!!touched.fName && !!errors.fName}
                helperText={touched.fName && errors.fName}
                sx={{ gridColumn: "span 2" }}
              />
              <Autocomplete
                disablePortal
                onChange={(event, value) =>
                  (initialValues.userType = value.label)
                }
                options={top100Films}
                sx={{ width: 300 }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="User Type"
                    onChange={handleChange}
                    name="institute"
                    value={values.userType}
                    onBlur={handleBlur}
                  />
                )}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Last Name"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.lName}
                name="lName"
                error={!!touched.lName && !!errors.lName}
                helperText={touched.lName && errors.lName}
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Email"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.email}
                name="email"
                error={!!touched.email && !!errors.email}
                helperText={touched.email && errors.email}
                sx={{ gridColumn: "span 4" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Contact Number"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.contact}
                name="contact"
                error={!!touched.contact && !!errors.contact}
                helperText={touched.contact && errors.contact}
                sx={{ gridColumn: "span 4" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Address 1"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.address1}
                name="address1"
                error={!!touched.address1 && !!errors.address1}
                helperText={touched.address1 && errors.address1}
                sx={{ gridColumn: "span 4" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Address 2"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.address2}
                name="address2"
                error={!!touched.address2 && !!errors.address2}
                helperText={touched.address2 && errors.address2}
                sx={{ gridColumn: "span 4" }}
              />
            </Box>
            <Box display="flex" justifyContent="end" mt="20px">
              <Button type="submit" color="secondary" variant="contained">
                Create New User
              </Button>
            </Box>
          </form>
        )}
      </Formik>
      <Box
        m="20px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
        }}
      >
        <DataGrid checkboxSelection rows={mockDataRequests} columns={columns} />
      </Box>
    </Box>
  );
};

const phoneRegExp =
  /^((\+[1-9]{1,4}[ -]?)|(\([0-9]{2,3}\)[ -]?)|([0-9]{2,4})[ -]?)*?[0-9]{3,4}[ -]?[0-9]{3,4}$/;

const checkoutSchema = yup.object().shape({
  fName: yup.string().required("required"),
  lName: yup.string().required("required"),
  email: yup.string().email("invalid email").required("required"),
  contact: yup
    .string()
    .matches(phoneRegExp, "Phone number is not valid")
    .required("required"),
  address1: yup.string().required("required"),
  address2: yup.string().required("required"),
});
const initialValues = {
  fName: "",
  lName: "",
  email: "",
  contact: "",
  address1: "",
  address2: "",
  userType: "Admin",
};

export default Form;
